import React, { useEffect, useRef, useState } from 'react';
import cheveron_icon from 'assets/icons/chevron-down.svg';
import { useTranslation } from 'react-i18next';
import { saveToStorage, getFromStorage } from 'utils/localstorage';
import { LANGUAGE, LOCAL_STORAGE } from 'constants/common';
import { getShortNameByCode } from 'utils/common';
import useClickOutside from 'hook/useClickOutside';
const SelectLanguage = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(getFromStorage(LOCAL_STORAGE.LANGUAGE));
  const [currentLanguage, setCurrentLanguage] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  console.log('currentLanguage', currentLanguage);

  const changeLanguageHandler = (langCode: string) => {
    saveToStorage(LOCAL_STORAGE.LANGUAGE, langCode);
    setLanguage(langCode);
    setCurrentLanguage(getShortNameByCode(langCode));
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const localesLanguage = getFromStorage(LOCAL_STORAGE.LANGUAGE);
    if (!localesLanguage) {
      saveToStorage(LOCAL_STORAGE.LANGUAGE, LANGUAGE.VIETNAMESE.code);
      i18n.changeLanguage(LANGUAGE.VIETNAMESE.code);
      setLanguage(LANGUAGE.VIETNAMESE.code);
      setCurrentLanguage(getShortNameByCode(LANGUAGE.VIETNAMESE.code));
    } else {
      setCurrentLanguage(getShortNameByCode(localesLanguage));
      i18n.changeLanguage(localesLanguage);
    }
  }, []);

  const handleOpenSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleCloseSidebar = () => {
    setIsOpen(false);
  };

  const clickOutsideRef = useRef(null);
  useClickOutside(clickOutsideRef, handleCloseSidebar);
  return (
    <div ref={clickOutsideRef}>
      <div className="relative">
        <div className="text-white flex gap-x-2 cursor-pointer" onClick={handleOpenSidebar}>
          <h3 className="font-semibold text-base">
            {/* {currentLanguage} */}
            LANGUAGE
          </h3>
          <img src={cheveron_icon} alt="cheveron_icon" width={16} height={16} />
        </div>
        {isOpen && (
          <div className={`w-[60px] mx-auto bg-white absolute z-[11px] top-[30px] rounded-[6px]`}>
            <div className="text-black">
              <div className="flex flex-col justify-center cursor-pointer py-4 gap-4">
                <div
                  className={`px-4 ${
                    currentLanguage === LANGUAGE.ENGLISH.shortName ? 'text-[#3D9AD5]' : ''
                  } `}
                  onClick={() => changeLanguageHandler(LANGUAGE.ENGLISH.code)}
                >
                  {LANGUAGE.ENGLISH.shortName}
                </div>

                <div
                  className={`px-4 ${
                    currentLanguage === LANGUAGE.VIETNAMESE.shortName ? 'text-[#3D9AD5]' : ''
                  }
                   
                  `}
                  onClick={() => changeLanguageHandler(LANGUAGE.VIETNAMESE.code)}
                >
                  {LANGUAGE.VIETNAMESE.shortName}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectLanguage;
